import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/find-and-fix/poi/$poiId')({
    component: () => <Outlet />,
});
